<template>
  <v-container fluid class="pa-2" style="margin-top: 2vh">
    <v-card
      class="mx-auto"
      max-width="900vh"
      height="15vh"
      style="margin-bottom: 20px"
      variant="outlined"
    >
      <div style="margin-left: 15px !important">
        <div class="text-overline mb-1">{{ organizationDetails.name }}</div>
        <div class="text-h6 mb-1">{{ organizationDetails.domain }}</div>
        <div class="text-caption">
          <span>{{ organizationDetails.address1 }}</span>
          <span>{{ organizationDetails.address2 }}</span>
          <span>{{ organizationDetails.address3 }}</span>
          <span>{{ organizationDetails.city }}</span>
          <span>{{ organizationDetails.state }}</span>
          <span>{{ organizationDetails.postalCode }}</span>
          <span>{{ organizationDetails.phone }}</span>
          <span>{{ organizationDetails.postalCode }}</span>
          <span>{{ organizationDetails.logo }}</span>
          <span>{{ organizationDetails.stylesheet }}</span>
        </div>
      </div>
    </v-card>
    <v-toolbar dense>
      <v-tabs v-model="tab" @change="onTabChange">
        <v-tab href="#projects"> Projects </v-tab>
        <v-tab href="#users"> Users </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="currentTab">
      <v-tab-item value="projects" style="margin-top: 10px">
        <div class="d-flex justify-space-between mb-6 bg-surface-variant">
          <v-row>
            <v-col>
              <v-data-table
                :headers="headersProjects"
                :items="
                  this.$store.state.OrganizationStore.projectsForOrganization
                "
                :items-per-page="10"
                class="elevation-1"
                :search="searchProjects"
              >
                <template v-slot:top>
                  <v-row class="upper-elements justify-end">
                    <v-col cols="2" sm="2" md="3">
                      <v-text-field
                        dense
                        v-model="searchProjects"
                        append-icon="mdi-magnify"
                        outlined=""
                        label="Search"
                        hide-details
                        class="mr-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <tr>
                    {{
                      item.name
                    }}
                  </tr>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon size="24" @click.once="removeProject(item)"
                    >close</v-icon
                  >
                </template>
              </v-data-table>
            </v-col>
            <v-col>
              <v-data-table
                :headers="headersNotAttachedProjects"
                :items="filteredProjects"
                :items-per-page="10"
                @click:row="connectProjectToOrganization"
                class="elevation-1"
                :search="searchNotAttachedprojects"
              >
                <template v-slot:top>
                  <v-row class="upper-elements justify-end">
                    <v-col cols="2" sm="2" md="3">
                      <v-text-field
                        dense
                        v-model="searchNotAttachedprojects"
                        append-icon="mdi-magnify"
                        outlined=""
                        label="Search"
                        hide-details
                        class="mr-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <tr>
                    {{
                      item.name
                    }}
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <v-tab-item value="users" style="margin-top: 10px">
        <div class="d-flex justify-space-between mb-6 bg-surface-variant">
          <v-row>
            <v-col>
              <v-data-table
                :headers="headersUsers"
                :items="
                  this.$store.state.OrganizationStore.usersForOrganization
                "
                :items-per-page="10"
                class="elevation-1"
                :search="searchUsers"
              >
                <template v-slot:top>
                  <v-row class="upper-elements justify-end">
                    <v-col cols="2" sm="2" md="3">
                      <v-text-field
                        dense
                        v-model="searchUsers"
                        append-icon="mdi-magnify"
                        outlined=""
                        label="Search"
                        hide-details
                        class="mr-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <tr>
                    {{
                      item.name
                    }}
                  </tr>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon size="24" @click="removeUser(item)">close</v-icon>
                </template>
              </v-data-table>
            </v-col>
            <v-col>
              <v-data-table
                :headers="headersNotAttachedUsers"
                :items="filteredUsers"
                :items-per-page="10"
                @click:row="connectUserToOrganization"
                class="elevation-1"
                :search="searchNotAttachedUsers"
              >
                <template v-slot:top>
                  <v-row class="upper-elements justify-end">
                    <v-col cols="2" sm="2" md="3">
                      <v-text-field
                        dense
                        v-model="searchNotAttachedUsers"
                        append-icon="mdi-magnify"
                        outlined=""
                        label="Search"
                        hide-details
                        class="mr-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <tr>
                    {{
                      item.name
                    }}
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('OrganizationStore/resetStore')
    next()
  },
  name: 'organizationList',
  props: {
    context: {
      type: String,
      required: false,
      default: 'projects'
    },
    contextUsers: {
      type: String,
      required: false,
      default: 'users'
    }
  },
  components: {},
  data: function() {
    return {
      editedIndex: -1,
      organizationDetails: {},
      fetchFilteredUsers: [],
      attachedUsers: [],
      fetchFilteredProjects: [],
      attachedProjects: [],
      tab: 'projects',
      currentTab: 'projects',
      editedItem: {
        id: 0,
        name: ''
      },
      defaultItem: {
        id: 0,
        name: ''
      },
      searchProjects: '',
      searchNotAttachedprojects: '',
      searchUsers: '',
      searchNotAttachedUsers: ''
    }
  },
  computed: {
    headersProjects() {
      return [
        {
          text: 'ATTACHED' + '  ' + this.context.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    headersNotAttachedProjects() {
      return [
        {
          text: this.context.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    headersUsers() {
      return [
        {
          text: 'ATTACHED' + '  ' + this.contextUsers.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    headersNotAttachedUsers() {
      return [
        {
          text: this.contextUsers.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    filteredUsers() {
      let attachedUsers = this.$store.state.OrganizationStore
        .usersForOrganization
      let fetchFilteredUsers = this.$store.state.UserStore.users
      let users = fetchFilteredUsers.filter(
        e => !attachedUsers.find(({ id }) => e.id === id)
      )
      return users
    },
    filteredProjects() {
      let attachedProjects = this.$store.state.OrganizationStore
        .projectsForOrganization
      let fetchFilteredProjects = this.$store.state.ProjectStore.projects
      let projects = fetchFilteredProjects.filter(
        e => !attachedProjects.find(({ id }) => e.id === id)
      )
      return projects
    }
  },
  async created() {
    await this.$store.dispatch(
      'OrganizationStore/setSelectedOrganization',
      this.$route.params.organizationId
    )
    this.$store.dispatch(
      'OrganizationStore/fetchProjectsForOrganization',
      this.$route.params.organizationId
    )
    this.$store.dispatch(
      'OrganizationStore/fetchUsersForOrganization',
      this.$route.params.organizationId
    )
    this.$store.dispatch('UserStore/fetchUsers')
    this.$store.dispatch('ProjectStore/fetchProjects')

    this.organizationDetails = this.$store.state.OrganizationStore.selectedOrganization
  },
  methods: {
    onTabChange() {
      this.currentTab = this.tab
    },
    async connectProjectToOrganization(project) {
      await this.$store.dispatch(
        'OrganizationStore/createOrganizationProject',
        {
          projectsId: project.id,
          organizationsId: parseInt(this.$route.params.organizationId)
        }
      )
      this.$store.dispatch(
        'OrganizationStore/fetchProjectsForOrganization',
        parseInt(this.$route.params.organizationId)
      )
    },
    connectUserToOrganization(user) {
      this.$store.dispatch('OrganizationStore/createOrganizationUser', {
        usersId: user.id,
        organizationsId: parseInt(this.$route.params.organizationId)
      })
      this.$store.dispatch(
        'OrganizationStore/fetchUsersForOrganization',
        this.$route.params.organizationId
      )
    },
    removeProject(project) {
      let data = {
        organizationsId: parseInt(this.$route.params.organizationId),
        projectsId: project.id
      }
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete ' + this.context,
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: async () => {
          await this.$store.dispatch(
            'OrganizationStore/removeOrganizationProject',
            data
          )
          this.$store.dispatch(
            'OrganizationStore/fetchProjectsForOrganization',
            data.organizationsId
          )
        },
        cancelText: 'Cancel'
      })
    },

    removeUser(user) {
      let data = {
        organizationsId: this.$route.params.organizationId,
        usersId: user.id
      }
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete ' + this.contextUsers,
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.$store.dispatch('OrganizationStore/removeOrganizationUser', data)
          this.$store.dispatch(
            'OrganizationStore/fetchUsersForOrganization',
            this.$route.params.organizationId
          )
        },
        cancelText: 'Cancel'
      })
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.upper-elements {
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.v-data-footer {
  margin-bottom: 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
